/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorControllerHealth200ResponseInfoValue } from './monitorControllerHealth200ResponseInfoValue';


export interface MonitorControllerHealth503Response { 
    status?: string;
    info?: { [key: string]: MonitorControllerHealth200ResponseInfoValue; } | null;
    error?: { [key: string]: MonitorControllerHealth200ResponseInfoValue; } | null;
    details?: { [key: string]: MonitorControllerHealth200ResponseInfoValue; };
}

